let intervalRef = null;

export function startTelemetrySimulator(dispatch, nodes) {
  if (intervalRef || typeof dispatch !== "function") return;
  intervalRef = setInterval(() => {
    // simulate minor current drift for any PDM channel
    nodes
      .filter((n) => n.subtype === "EWL-810")
      .forEach((n) => {
        (n.channels || []).forEach((ch) => {
          if (!ch.ownerDeviceId) return;
          const current = (0.8 + Math.random() * 1.2).toFixed(2);
          dispatch({
            type: "channels/updateMetrics",
            nodeId: n.id,
            channelIndex: ch.index,
            metrics: { current, fuseState: "ok", updatedAt: Date.now() },
          });
        });
      });
  }, 2500);
}

export function stopTelemetrySimulator() {
  if (intervalRef) {
    clearInterval(intervalRef);
    intervalRef = null;
  }
}
